import React, { useState, useEffect, useRef } from "react";
import MainScreen from "../../components/MainScreen";
import { Table, Button, Row, Col, Form, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { registerEmployee, selectUser } from "../../features/userSlice";
import Loading from "../../components/Loading";
import ErrorMessage from "../../components/ErrorMessage";
import "./Employee.css";
import axios from "axios";
import "./Paginated1.css";
import "./Paginated2.css";
import moment from 'moment'; // You can use the moment library for date formatting

const ManageEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [errors, setErrors] = useState({}); // State for errors
  const [formData, setFormData] = useState({
    employee_code: "",
    display_name: "",
    sh_group: "",
    sh_group_eff_from: "",
    created_by: "",
    created_date: "",
    modified_by: "",
    modified_date: "",
  });

  const [shiftGroups, setShiftGroups] = useState([]); // To store shift groups

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const timezoneOffset = new Date().getTimezoneOffset();
  const timezoneOffsetInHours = timezoneOffset / 60;

  const user = useSelector(selectUser);
  const emp_id = user?.emp_id;
  const token = user?.token;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const employeeIdRef = useRef(null); // Ref for employee_code input field

  useEffect(() => {
    fetchEmployees();
    fetchShiftGroups(); // Fetch shift groups for the dropdown
  }, []);

  useEffect(() => {
    const filtered = employees.filter((employee) =>
      employee.display_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      employee.employee_code.toLowerCase().includes(searchTerm.toLowerCase())

    );
    setFilteredEmployees(filtered);
  }, [searchTerm, employees]);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const response = await axios.post("/api/attendance/getShGrpAlloc"); // Adjust URL as per your backend API
      const employeesData = Array.isArray(response.data)
        ? response.data
        : [response.data];
      setEmployees(employeesData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching employees:", error);
      setLoading(false);
      // Handle error state as needed
    }
  };

 // Fetch shift groups for the dropdown
 const fetchShiftGroups = async () => {
  try {
    const response = await axios.get("/api/attendance/getShiftGroups"); // Adjust API endpoint as necessary
    setShiftGroups(response.data);
  } catch (error) {
    console.error("Error fetching shift groups:", error);
  }
  };

  const handleAddNewRecord = () => {
    setSelectedEmployee(null); // Reset form
    clearForm();
    employeeIdRef.current.focus(); // Set focus on employee_code input field
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1); // Reset to first page when items per page change
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getCurrentDateTime = () => {
    const now = new Date();
    const formattedDate = now.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:mm"
    return formattedDate + "Z";
  };
  const formatDateTimeForInput = (dateTime) => {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const convertLocalTimeToUTC = (localDateTime) => {
    const localDate = new Date(localDateTime);
    return localDate.toISOString();
  };
  // Function to convert UTC datetime to local time
  const convertUTCToLocalTime = (utcDateTime) => {
    const localDate = new Date(utcDateTime);
    return localDate.toLocaleString();
  };
  const clearForm = () => {
    setFormData({
      employee_code: "",
      display_name: "",
      sh_group: "",
      sh_group_eff_from: "",
    });
  };

  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [error1, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  // Validation function
  const validateForm = () => {
    const newErrors = {};

    if (!formData.employee_code) {
      newErrors.employee_code = "Employee Code is required.";
    }
    if (!formData.sh_group) {
      newErrors.sh_group = "Shift Group is required.";
    } 

    if (!formData.sh_group_eff_from) {
      newErrors.sh_group_eff_from = "Effective From Date is required.";
    }
    // Add more validation rules as needed

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setMessage("Please fix the validation errors before submitting.");
      return;
    }

    setError(false);
    setLoading(true);

    try {
      const updatedFormData = {
        ...formData,
      };

      let result;
      if (selectedEmployee) {
        const localDate = new Date(); // Assuming this is the local date you want to store
        const utcDate = convertLocalTimeToUTC(localDate);
        const tmp_date = formatDateTimeForInput(new Date());
        const utcDateFromBackend = "2024-06-18T12:31:34.945Z";
        const localDateForDisplay = convertUTCToLocalTime(utcDateFromBackend);

        const updatedFormData1 = {
          ...updatedFormData,
          sh_group_eff_from: updatedFormData.sh_group_eff_from
            ? formatDateForInput(updatedFormData.sh_group_eff_from)
          : null,
          created_by: null,
          created_date: null,
          modified_by: emp_id,
          modified_date: formatDateTimeForInput(new Date()),
  
        };
        // Edit existing employee
        result = await axios.put(
          `/api/attendance/updShGrpAlloc`,
          updatedFormData1
        );
      } else {
        // Add new employee
        const updatedFormData1 = {
          ...updatedFormData,
          modified_by: null,
          modified_date: null,
          sh_group_eff_from: updatedFormData.sh_group_eff_from
            ? formatDateForInput(updatedFormData.sh_group_eff_from)
            : null,
          created_by: emp_id,
          created_date: formatDateTimeForInput(new Date()),
        };
        // Edit existing employee
        result = await axios.post(`/api/attendance/addShGrpAlloc`, updatedFormData1 );
      }

      if (result.data || result.payload) {
        setShowSuccessModal(true);
        fetchEmployees(); // Refresh the employee data
        setSelectedEmployee(null); // Reset form
        clearForm();
      } else if (result.error) {
        setShowErrorModal(true);
        console.error("Error:", result.error);
        setError(true);
        setMessage(result.error.message || "Submission failed.");
      }
      setLoading(false);
    } catch (error) {
      setShowErrorModal(true);
      console.error("Submit Error:", error);
      setError(true);
      setLoading(false);
    }
  };

  const handleSuccessModalClose = () => {
    setShowSuccessModal(false);
    setErrors({}); // Clear validation errors
    setMessage(""); // Clear error message
    navigate("/manageShGrpAlloc"); // Navigate to the home route after closing the modal
  };

  const handleEmployeeClick = (employee) => {
    setErrors({}); // Clear validation errors
    setMessage(""); // Clear error message

    setFormData({
      employee_code: employee.employee_code,
      display_name: employee.display_name,
      sh_group: employee.sh_group, // This will set the correct shift group code
      sh_group_eff_from: employee.sh_group_eff_from ? formatDateForInput(employee.sh_group_eff_from)  : null,
      created_by: employee.created_by,
      created_date: employee.created_date
        ? formatDateTimeForInput(employee.created_date)
        : "",
      modified_by: employee.modified_by,
      modified_date: employee.modified_date
        ? formatDateTimeForInput(employee.modified_date)
        : "",
    });
    setSelectedEmployee(employee);
  };

  if (!token) {
    return (
      <div>
        <p>You must be logged in to register a employee.</p>
        <button onClick={() => navigate("/")}>Go to Login</button>
      </div>
    );
  }

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredEmployees.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);

  const TimezoneInfo = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezoneOffset = new Date().getTimezoneOffset();
    const timezoneOffsetInHours = timezoneOffset / 60;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB"); // 'en-GB' will format the date as dd/mm/yyyy
  };
  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    //const hours = String(date.getHours()).padStart(2, "0");
    //const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}`; // This is the correct format for datetime-local
  };


  return (
    <MainScreen title="Manage Shift Group Allocation">
      <div className="employee-list">
        <div className="Paginated1">
          <Table responsive striped bordered hover>
            <thead style={{ height: "50%", verticalAlign: "midle" }}>
              <td
                style={{ height: "50$", width: "5%", verticalAlign: "midle" }}
              >
                No.Records:
              </td>
              <td width={"5%"}>
                <div>
                  <Form.Control
                    as="select"
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                  </Form.Control>
                </div>
              </td>

              <td>
                <div
                  className="pagination-buttons"
                  style={{ width: "68%", color: "lightskyblue" }}
                >
                  <Button
                    variant="secondary"
                    onClick={() => handlePageChange(1)}
                    disabled={currentPage === 1}
                  >
                    {"<<"}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    {"<"}
                  </Button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <Button
                    variant="secondary"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    {">"}
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => handlePageChange(totalPages)}
                    disabled={currentPage === totalPages}
                  >
                    {">>"}
                  </Button>
                </div>
              </td>
              <td width={"5%"}></td>
              <td>
                <Form.Control
                  type="text"
                  placeholder="Search by name"
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </td>
              <td className="button-cell">
                <Button variant="primary" onClick={() => handleAddNewRecord()}>
                  Add
                </Button>
                <Button variant="secondary">Upload</Button>
                <Button variant="secondary">Export</Button>
              </td>
            </thead>
          </Table>
        </div>
        <div className="Paginated2">
          <Table responsive striped bordered hover>
            <thead>
              <tr>
                <th>Employee Code</th>
                <th>Display Name</th>
                <th>Shift Group</th>
                <th>Effective From</th>
                <th>Created By</th>
                <th>Created Date</th>
                <th>Modified By</th>
                <th>Modified Date</th>
                {/* Add more headers as needed */}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((employee) => (
                <tr key={employee.employee_code}>
                  <td>
                    <a href="#" onClick={() => handleEmployeeClick(employee)}>
                      {employee.employee_code}
                    </a>
                  </td>
                  <td> {employee.display_name} </td>
                  <td> {employee.sh_group} </td>
                  <td> { employee.sh_group_eff_from ? moment(employee.sh_group_eff_from).format('DD/MM/YYYY') : "" } </td>
                  <td> {employee.created_by} </td>
                  <td> { employee.created_date ? moment(employee.created_date).format('DD/MM/YYYY') : "" } </td>
                  <td> {employee.modified_by} </td>
                  <td> { employee.modified_date ? moment(employee.modified_date).format('DD/MM/YYYY') : "" } </td>
                  {/* Add more columns as needed */}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="loginContainer">
        {error1 && (
          <ErrorMessage variant="danger">
            Unable to Register, Please check data
          </ErrorMessage>
        )}
        {message && <ErrorMessage variant="danger">{message}</ErrorMessage>}
        {loading && <Loading />}
        <Form onSubmit={submitHandler}>
          <Form.Group controlId="employee_code" className="formGroup">
            <Form.Label>Employee Code</Form.Label>
            <Form.Control
              type="text"
              name="employee_code"
              value={formData.employee_code}
              placeholder="Enter Employee Code"
              onChange={handleChange}
              ref={employeeIdRef}
            />
            {errors.employee_code && (
              <div className="error-message">{errors.employee_code}</div>
            )}
          </Form.Group>
          <Form.Group controlId="display_name" className="formGroup">
            <Form.Label>Display Name</Form.Label>
            <Form.Control
              type="text"
              name="display_name"
              value={formData.display_name}
              placeholder="Enter Display Name"
              readOnly
            />
          </Form.Group>
        {/* Shift Group Dropdown */}
        <Form.Group controlId="sh_group" className="formGroup">
          <Form.Label>Shift Group</Form.Label>
          <Form.Control
            as="select"
            name="sh_group"
            value={formData.sh_group}
            onChange={handleChange}
          >
            <option value="">Select Shift Group</option>
            {shiftGroups.map((group) => (
              <option key={group.sh_group} value={group.sh_group}>
                {`${group.sh_group} - ${group.timing}`}
              </option>
            ))}
          </Form.Control>
          {errors.sh_group && (
            <div className="error-message">{errors.sh_group}</div>
          )}
        </Form.Group>
        <Form.Group controlId="sh_group_eff_from" className="formGroup">
        <Form.Label>Effective From Date</Form.Label>
        <Form.Control
          type="date" // Ensure datetime-local type is used
          name="sh_group_eff_from"
          value={
            formData.sh_group_eff_from
              ? formatDateForInput(formData.sh_group_eff_from) // Ensure it reflects the selected date and time
              : ""
          }
          onChange={handleChange} // Handle the date and time selection
        />
        {errors.sh_group_eff_from && (
          <div className="error-message">{errors.sh_group_eff_from}</div>
        )}
        </Form.Group>
          <Form.Group controlId="created_by" className="formGroup">
            <Form.Label>Created By</Form.Label>
            <Form.Control
              type="text"
              name="created_by"
              value={formData.created_by}
              readOnly
            />
          </Form.Group>
          <Form.Group controlId="created_date" className="formGroup">
            <Form.Label>Created Date</Form.Label>
            <Form.Control
              type="datetime-local"
              name="created_date"
              value={
                formData.created_date
                  ? formatDateTimeForInput(formData.created_date)
                  : ""
              }
              readOnly
            />
          </Form.Group>

          <Form.Group controlId="modified_by" className="formGroup">
            <Form.Label>Modified By</Form.Label>
            <Form.Control
              type="text"
              name="modified_by"
              value={formData.modified_by}
              readOnly
            />
          </Form.Group>
          <Form.Group controlId="modified_date" className="formGroup">
            <Form.Label>Modified Date</Form.Label>
            <Form.Control
              type="datetime-local"
              name="modified_date"
              value={
                formData.modified_date
                  ? formatDateTimeForInput(formData.modified_date)
                  : ""
              }
              readOnly
            />
          </Form.Group>
          <div className="submit-button">
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </div>
        </Form>

        <Row className="py-3">
          <Col>
            Existing User? <Link to="/login">Login Here</Link>
          </Col>
        </Row>
      </div>

      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>Unable to register</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showSuccessModal} onHide={handleSuccessModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>User Registered Successfully</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSuccessModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </MainScreen>
  );
};

export default ManageEmployees;
